import React, { useMemo } from 'react'
import { Button, List } from 'antd'
import cls from 'classnames'
import styles from './style.module.scss'
import { useWebConfigServiceQuery } from 'core/query/hk-web/common/query'
import { useLocale } from 'core/components/Locale'
import { useCopy } from '@/hooks/useCopy'
import DownloadQRCode from '@/bizComponents/DownloadQRCode'
import { useHCRouter } from '@/components/HCNextLink'

type TProps = {
  visible: boolean
}

const DownloadPop: React.FC = (props: TProps) => {
  const router = useHCRouter()
  const t = useLocale()
  const { copyTextWithNotification } = useCopy()
  const { data } = useWebConfigServiceQuery({ enabled: props.visible })

  const webSiteList = useMemo(() => {
    return data?.data?.data?.backupWebsites?.slice(0, 3) || []
  }, [data])

  const go = (path: string) => {
    window.location.href = path
  }

  const handleCopy = (value: string) => {
    copyTextWithNotification(value)
  }

  const openWebsite = (url: string) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'http://' + url
    }
    window.open(url, '_blank')
  }

  return (
    <div className={cls(styles['header-download'], styles['header-drop'])}>
      <div className={cls(styles['download-wrap'], styles['border-color-wb4'])}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <DownloadQRCode />
        <div className={styles.title}>{t('download_page_01')}</div>
        <Button className={cls(styles['button'])} onClick={() => router.push('/app/downLoad', { target: '_blank' })}>
          {t('download_page_02')}
        </Button>
      </div>

      <div className={styles.websites}>
        <div className={styles.title}>{t('hotcoinWeb_v1_22_21_AlternativeDomainName')}</div>
        <div className={styles.desc}>{t('hotcoinWeb_v1_22_21_ItIsRecommendedThat_1')}</div>
        <List
          dataSource={webSiteList}
          className={cls(styles['site-list'])}
          renderItem={(item) => (
            <List.Item className={cls(styles['site-item'], 'bgc22')}>
              <span className="c7" onClick={() => openWebsite(item)}>
                {item}
              </span>
              <i
                className={cls('iconfont', 'iconfuzhi', styles.copy, styles['color-wb12'])}
                onClick={() => handleCopy(item)}
              ></i>
            </List.Item>
          )}
        />
      </div>
    </div>
  )
}

export default DownloadPop
